import { Skeleton } from './Skeleton';

export type SkeletonAvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const SIZE_PX: Record<SkeletonAvatarSize, string> = {
    xs: '24px',
    sm: '32px',
    md: '40px',
    lg: '56px',
    xl: '72px',
};

export function SkeletonAvatar({
    size = 'md',
    className = '',
}: {
    size?: SkeletonAvatarSize;
    className?: string;
}) {
    const dim = SIZE_PX[size];
    return <Skeleton width={dim} height={dim} shape="circle" className={className} />;
}
